import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import TeamSquad from '../TeamSquad';
import { transferShowUnshowFilter } from '../../../../../../redux/actions/Transfers';
import {
  playerFromList,
  isPlayerDataLoading,
  getMyAllSquad,
} from '../../../../../../redux/selector/Team';
import { StyledTableLoader } from '../../../../../../globalStyled';

export default function TransfersDeals() {
  const dispatch = useDispatch();
  const selectedPlayer = useSelector(playerFromList);
  const isLoading = useSelector(isPlayerDataLoading);
  const myTeam = useSelector(getMyAllSquad);

  useEffect(() => {
    dispatch(transferShowUnshowFilter(false));
    return () => dispatch(transferShowUnshowFilter(false));
  }, [dispatch]);

  if (isLoading) {
    return (
      <StyledTableLoader
        type="Bars"
        color="var(--tol-header-accent)"
        height={100}
        width={100}
      />
    );
  }

  if (!selectedPlayer) {
    return null;
  }

  const isOwnPlayer = myTeam.some((player) => player._id === selectedPlayer._id);

  return <TeamSquad searchPage={!isOwnPlayer} dealsPage />;
}
